import TextContent from "./TextContent";


const ServiceDescriptions = { 
    'Office and Warehouse LED Lighting': <TextContent.OFFICE_LED_LIGHTING/>,
    'Commercial Electrical Wiring': <TextContent.COMMERCIAL_ELECTRICAL_WIRING/>,
    'Communications': <TextContent.COMMUNICATIONS/>,
    'Panel & Sub-panel Replacement and Upgrades': <TextContent.PANEL_REP_UPGRADES/>,
    
    'Electrical Panel Upgrades': <TextContent.ELECTRICAL_PAN_UPGRADES/>,
    'Electrical Repair Services': <TextContent.ELECTRICAL_REPAIR/>,
    'Indoor Lighting': <TextContent.INDOOR_LIGHTING/>,
    'Electrical Vehicle Charger Installation': <TextContent.ELECTRICAL_VEH_CHG_INST/>,
};

export default ServiceDescriptions;